import { render, staticRenderFns } from "./NecesityResultRow.vue?vue&type=template&id=4e9909f6&scoped=true"
import script from "./NecesityResultRow.vue?vue&type=script&lang=js"
export * from "./NecesityResultRow.vue?vue&type=script&lang=js"
import style0 from "./NecesityResultRow.vue?vue&type=style&index=0&id=4e9909f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9909f6",
  null
  
)

export default component.exports